import React from 'react'
import '../styles/globals.css'
import type { AppProps } from 'next/app'

import { EthersProvider } from 'lib/contexts/ethers'
import { PolkadotProvider } from 'lib/contexts/polkadot'

function App({ Component, pageProps }: AppProps) {
  return (
    <EthersProvider>
      <PolkadotProvider>
        <Component {...pageProps} />
      </PolkadotProvider>
    </EthersProvider>
  )
}

export default App
